<template>
    <!-- header -->
    <el-container class="main-container" id="fb-root">
        <el-header height="auto" class="site-header">
            <el-row type="flex" align="middle" class="header-content">
                <el-col :xs="24" :sm="6" class="logo-col">
                    <div class="logo-wrapper">
                        <img src="../assets/images/searchplus.png" alt="Search++ Logo" class="logo-image">
                    </div>
                </el-col>
                <el-col :xs="24" :sm="18" class="info-col">
                    <div class="header-info">
                        <h1 class="main-title">
                            {{ $t('home.title1') }}<br>
                            <span>{{ $t('home.title2') }}</span>
                        </h1>
                        <div class="header-meta">
                            <div class="lang-switch">
                                <a :class="{ active: $lang === 'ja' }" @click="$switchLang('ja')">
                                    <img :src="flagJa" class="lang-flag" alt="日本語"> 日本語
                                </a>
                                <span class="lang-sep">|</span>
                                <a :class="{ active: $lang === 'en' }" @click="$switchLang('en')">
                                    <img :src="flagEn" class="lang-flag" alt="English"> English
                                </a>
                            </div>
                            <span class="update-date"><i class="el-icon-time"></i> {{ $t('home.updateDate') }}</span>
                            <div class="eval-links">
                                <a href="https://www.vector.co.jp/magazine/softnews/130524/n1305241.html" class="eval-link vector">{{ $t('home.evalLabel') }}</a>
                            </div>
                            <div class="social-share">
                                <div class="fb-share-button" data-href="https://www.searchplusplus.jp" data-layout="button_count"></div>
                                <div class="fb-send" data-href="https://www.searchplusplus.jp"></div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row class="nav-row">
                <el-col :span="24">
                    <nav aria-label="Main Navigation">
                        <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" router class="main-nav">
                            <el-menu-item v-for="(item, index) in navItems" :key="index" :index="navIndexes[index]">{{ item }}</el-menu-item>
                        </el-menu>
                    </nav>
                </el-col>
            </el-row>
        </el-header>
        <!-- main -->
        <el-main>
            <router-view></router-view>
        </el-main>
        <!-- footer: Copyright and facebook  -->
        <el-footer>
        <div>
            <div class="copyright">
                <p>{{ $t('common.copyright') }}</p>
            </div>
            <iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.searchplusplus.jp&amp;send=false&amp;layout=standard&amp;width=450&amp;show_faces=true&amp;action=like&amp;colorscheme=light&amp;font&amp;height=80" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:450px; height:80px;" allowTransparency="true">
            </iframe>
        </div>
        </el-footer>
    </el-container>
</template>

<script>
import flagJa from '../assets/images/flag-jp.svg'
import flagEn from '../assets/images/flag-gb.svg'

export default {
  data () {
    return {
      activeIndex: '',
      navIndexes: ['/Index', '/feature', '/release', '/voiceofcustomer', '/download', '/link', '/contact', '/register'],
      flagJa: flagJa,
      flagEn: flagEn
    }
  },
  computed: {
    navItems () {
      return this.$t('nav.items')
    }
  },
  methods: {
    handleSelect (key, keyPath) {
    }
  }
}
</script>

<style scoped>
.main-container {
    margin: 0 auto;
    max-width: 1200px;
    width: 95%;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0,0,0,0.05);
    min-height: 100vh;
}

.site-header {
    background: linear-gradient(to bottom, #f8f9fa, #ffffff);
    padding: 20px 0 0 0;
    border-bottom: 1px solid #ebeef5;
}

.header-content {
    padding: 0 20px;
    flex-wrap: wrap;
}

.logo-col {
    display: flex;
    justify-content: center;
    padding: 10px 0;
}

.logo-wrapper {
    background: #fff;
    padding: 10px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    transition: transform 0.3s ease;
}

.logo-wrapper:hover {
    transform: translateY(-2px);
}

.logo-image {
    max-width: 160px;
    width: 100%;
    height: auto;
}

.info-col {
    padding-left: 20px;
}

@media (max-width: 768px) {
    .info-col {
        padding-left: 0;
        text-align: center;
    }
    .header-meta {
        justify-content: center;
    }
}

.main-title {
    margin: 0 0 10px 0;
    font-size: 24px;
    color: #2c3e50;
    line-height: 1.4;
}

.main-title span {
    color: #409EFF;
    font-size: 28px;
    font-weight: 800;
}

.header-meta {
    font-size: 14px;
    color: #606266;
}

.lang-switch {
    float: right;
    margin: 0 0 8px 16px;
    font-size: 13px;
}

.lang-switch a {
    cursor: pointer;
    color: #909399;
    text-decoration: none;
    font-weight: 500;
}

.lang-switch a:hover,
.lang-switch a.active {
    color: #409EFF;
}

.lang-flag {
    width: 19px;
    height: 13px;
    vertical-align: -2px;
    margin-right: 4px;
    border-radius: 2px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
}

.lang-sep {
    margin: 0 6px;
    color: #dcdfe6;
}

.update-date {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

.eval-links {
    margin-bottom: 10px;
}

.eval-link {
    display: inline-block;
    margin-right: 15px;
    padding: 4px 12px;
    border-radius: 20px;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
}

.eval-link.vector {
    background-color: #fdf6ec;
    color: #e6a23c;
    border: 1px solid #faecd8;
}

.eval-link:hover {
    opacity: 0.8;
    transform: scale(1.02);
}

.nav-row {
    margin-top: 20px;
}

.main-nav {
    border-bottom: none !important;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.el-menu-item {
    font-size: 16px;
    color: #606266 !important;
    height: 50px !important;
    line-height: 50px !important;
    border-bottom: 3px solid transparent !important;
    transition: all 0.3s ease !important;
}

.el-menu-item:hover, .el-menu-item.is-active {
    background-color: transparent !important;
    color: #409EFF !important;
    border-bottom: 3px solid #409EFF !important;
}

.copyright {
    text-align: center;
    padding: 20px 0;
    color: #909399;
}

.el-footer {
    border-top: 1px solid #ebeef5;
    height: auto !important;
    padding: 20px;
}

@media (max-width: 600px) {
    .el-menu-item {
        padding: 0 10px !important;
        font-size: 14px;
    }
}
</style>
